import React, { Component } from 'react';
import styles from './style';
import { View } from 'react-native-web';

export default class Entete extends Component {
  render () {
    return <View style={styles.entete}>{this.props.children}</View>;
  }
}
